import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export enum ACCOMMODATIONS_ACTIONS {
  ACCOMMODATIONS_ADD = 'accommodations_add',
  ACCOMMODATIONS_HOTEL_ADD = 'accommodations_hotel_add',
  ACCOMMODATIONS_HOTEL_EDIT = 'accommodations_hotel_edit',
  ACCOMMODATIONS_CUSTOM_PROPERTY_ADD = 'accommodations_custom_property_add',
  ACCOMMODATIONS_CUSTOM_PROPERTY_EDIT = 'accommodations_custom_property_edit',
}

export const ACCOMMODATIONS_SCREENS = [
  ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD,
  ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_ADD,
  ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_EDIT,
  ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_ADD,
  ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_EDIT,
];

export const CUSTOM_PROPERTY_ADD_KEY = 'isCustomAddProperty';

export const ACCOMMODATIONS_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_EDIT,
      animationType: ANIMATION_TYPES.CHILD_VIEW_RIGHT_SLIDE,
    },
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_EDIT,
      animationType: ANIMATION_TYPES.CHILD_VIEW_RIGHT_SLIDE,
    },
  ],
  [ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_ADD]: [
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.CHILD_VIEW_LEFT_SLIDE,
    },
  ],
  [ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_ADD]: [
    {
      navigatedFrom: ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.CHILD_VIEW_LEFT_SLIDE,
    },
  ],
};
